/* @ngInject */
export default class PersonalDocumentsCtrl {
	constructor(
		$scope,
		$state,
		$window,
		Utility,
		$timeout,
		$rootScope,
		TelemetryService,
		BuildingsService,
		NavigationService,
		NotificationService,
		LocalStorageService,
		InternalLinksService,
		personalDocumentsDataService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$window = $window;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.TelemetryService = TelemetryService;
		this.BuildingsService = BuildingsService;
		this.NavigationService = NavigationService;
		this.NotificationService = NotificationService;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;
		this.personalDocumentsDataService = personalDocumentsDataService;

		this.init();
		this.activate();
	}

	init() {
		this.loading = true;
		this.personalDocumentsFlatFile = [];
		this.personalDocuments = [];
		this.content = undefined;
		this.selectedCardCode = null;
		this.selectedFolder = null;
		this.personalDocumentsBreadCrumbs = [
			{
				Title: 'Home',
				Level: null,
				Id: null,
				ParentId: null
			}
		];
		this._switchIsBusy(false);
		this.$scope.$on('selected-building-changed', (event, newValue) => {
			this.onSelectedBuildingChanged(event, newValue);
		});
	}

	activate() {
		this._switchIsBusy(true);
		if (this.$state.params && this.$state.params.hasOwnProperty('cardCode')) {
			this.selectedCardCode = this.$state.params.cardCode;
		}
		if (this.$state.params && this.$state.params.hasOwnProperty('folder')) {
			this.selectedFolder = this.$state.params.folder;
		}
		this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();
		if (this.selectedCardCode) { //Account History selectedbuilding Invoices 
			this.selectedBuildingRef = this.selectedCardCode.substring(1, 4);
		}
		if (!!!this.selectedBuildingRef) {
			const userProfile = this.LocalStorageService.retrieve('userProfile');
			const { BuildingProfiles } = userProfile;
			if (BuildingProfiles && BuildingProfiles.length > 0) {
				this.selectedBuildingRef = BuildingProfiles[0].SchemeReference;
			}
		}
		this.onSelectedBuildingChanged({}, this.selectedBuildingRef);
	}

	async getPersonalDocuments(schemeRef) {
		this.personalDocumentsFlatFile = [];
		this.personalDocuments = [];
		this._switchIsBusy(true);
		try {
			const data = await this.personalDocumentsDataService.getPersonalDocuments(schemeRef);
			data.forEach((document) => {
				this.personalDocumentsFlatFile.push(document);
				this.personalDocuments.push(document);
			});

			this.personalDocumentsBreadCrumbs = [
				{
					Title: 'Home',
					Level: null,
					Id: null,
					ParentId: null
				}
			];
		} catch (err) {
			this.NotificationService.error('COULD NOT PERSONAL DOCUMENTS');
			console.error(err);
		} finally {
			if (this.selectedCardCode) {
				this.openCardCodeFolder();
			} else {
				this._switchIsBusy(false);
			}
		}
	}

	onSelectedBuildingChanged(event, schemeRef) {
		this._switchIsBusy(true);
		this.SchemeRef = schemeRef ? schemeRef : this.selectedBuildingRef;
		if (this.SchemeRef && this.SchemeRef.length > 2) {
			this._switchIsBusy(true);
			this.getPersonalDocuments(schemeRef);
		}
		//this.$parent.loadTilesData();
	}

	openFiles() {
		$('.open-docs').trigger('click');
	}

	async personalDocumentsFolderClick(id) {
		this.NavigationService.gotoTop();
		let document;
		for (let i = 0; i < this.personalDocumentsFlatFile.length; i++) {
			document = this.personalDocumentsFlatFile[i];
			if (document.Id === id) {
				break;
			}
		}

		if (document.Level === 0 || document.Level === 1 || document.Level === 2) {
			const tempBreadCrumbs = {
				Title: document.Title,
				Level: document.Level,
				Id: document.Id,
				ParentId: document.ParentId
			};

			this.personalDocumentsBreadCrumbs.push(tempBreadCrumbs);
			const index = _.findIndex(this.personalDocumentsFlatFile, (doc) => doc.Id === document.Id);

			this.personalDocumentsFlatFile = this.personalDocumentsFlatFile[index].Children;

			return;
		}

		if (document.Level === 3) {
			const baseURL = this.InternalLinksService.getLink('GetPersonalDocumentById');
			const url = baseURL.replace('{id}', document.Id);

			const documentTab = this.$window.open(url, '_blank');
			documentTab.document.title = document.Title;

			try {
				const description = `Document ID: ${id}`;
				await this.TelemetryService.logTelemetry('View Personal Document', description);
			} catch (error) {
				console.error(`Error while logging Telemetry for Personal Document: ${description}`);
			}
			return;
		}
	}

	personalDocumentsBreadCrumbClick(breadCrumb) {
		const length = this.personalDocumentsBreadCrumbs.length;
		if (this.personalDocumentsBreadCrumbs[length - 1].Id === breadCrumb.Id) {
			return;
		}

		if (breadCrumb.Level === null) {
			this.personalDocumentsFlatFile = [];
			this.personalDocumentsBreadCrumbs = [
				{
					Title: 'Home',
					Level: null,
					Id: null,
					ParentId: null
				}
			];
			this.personalDocumentsFlatFile = this.personalDocuments;
			return;
		}

		if (breadCrumb.Level === 0 || breadCrumb.Level === 1) {
			for (let i = 0; i < this.personalDocuments.length; i++) {
				const topLevelDocument = this.personalDocuments[i];
				if (topLevelDocument.Id === breadCrumb.Id) {
					this.personalDocumentsFlatFile = topLevelDocument.Children;
					if (length === 4) {
						this.personalDocumentsBreadCrumbs.pop();
					}

					this.personalDocumentsBreadCrumbs.pop();

					return;
				}
				for (let j = 0; j < topLevelDocument.Children.length; j++) {
					const documentOrignal = topLevelDocument.Children[j];
					if (documentOrignal.Id === breadCrumb.Id) {
						this.personalDocumentsFlatFile = documentOrignal.Children;
						this.personalDocumentsBreadCrumbs.splice(-1, 1);
						return;
					}
				}
			}
		}

		if (breadCrumb.Level === 2) {
			return;
		}
	}

	openCardCodeFolder() {
		if (this.personalDocumentsFlatFile && this.personalDocumentsFlatFile.length > 0) {
			if (this.personalDocumentsFlatFile[0].Level === 0) {
				let document;
				for (let i = 0; i < this.personalDocumentsFlatFile.length; i++) {
					document = this.personalDocumentsFlatFile[i];
					if (document.Title === this.selectedCardCode) {
						break;
					}
				}

				const tempBreadCrumbs = {
					Title: document.Title,
					Level: document.Level,
					Id: document.Id,
					ParentId: document.ParentId
				};

				this.personalDocumentsBreadCrumbs.push(tempBreadCrumbs);
				const index = _.findIndex(this.personalDocumentsFlatFile, (doc) => doc.Id === document.Id);

				this.personalDocumentsFlatFile = this.personalDocumentsFlatFile[index].Children;
			}
			if (this.selectedFolder) {
				this.openFolder();
			} else {
				this._switchIsBusy(false);
			}

			return;
		}

		this._switchIsBusy(false);
	}

	openFolder() {
		if (this.personalDocumentsFlatFile && this.personalDocumentsFlatFile.length > 0) {
			if (this.personalDocumentsFlatFile[0].Level === 1) {
				let document;
				for (let i = 0; i < this.personalDocumentsFlatFile.length; i++) {
					document = this.personalDocumentsFlatFile[i];
					if (document.Title === this.selectedFolder) {
						break;
					}
				}

				const tempBreadCrumbs = {
					Title: document.Title,
					Level: document.Level,
					Id: document.Id,
					ParentId: document.ParentId
				};

				this.personalDocumentsBreadCrumbs.push(tempBreadCrumbs);
				const index = _.findIndex(this.personalDocumentsFlatFile, (doc) => doc.Id === document.Id);

				this.personalDocumentsFlatFile = this.personalDocumentsFlatFile[index].Children;
			}
		}

		this._switchIsBusy(false);
	}

	_switchIsBusy(flag) {
		this.$timeout(() => {
			this.isBusy = flag;
		});
	}
}
